import React from "react";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";

const TermsAndConditions: React.FC = () => {
  const terms = [
    "A 50% deposit is required to confirm the booking.",
    "Final payment is due 48 hours before the scheduled service date.",
    "Cancellations made within 72 hours of the service are non-refundable.",
    "Additional travel fees may apply for venues beyond 50 miles from our location.",
    "This quotation is valid for 30 days from the date of issue.",
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Terms & Conditions
      </Typography>

      <List dense>
        {terms.map((term, index) => (
          <ListItem key={index} sx={{ px: 0, py: 0.5 }}>
            <ListItemText
              primary={`• ${term}`}
              primaryTypographyProps={{ variant: "body2" }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default TermsAndConditions;
